%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 17c14f584f7d29740952e55a51d6a1fe, type: 3}
  m_Name: PracticeDummy
  m_EditorClassIdentifier: 
  unitModel: {fileID: 3241138547371686306, guid: 66f695610850be44c807d6bc9a95c019,
    type: 3}
  heroClass: 23
  isHealer: 0
  isInternal: 1
  isBoss: 0
  level: 0
  attackSpeed: 1
  baseHP: 2000
  baseGCDMultiplier: 0
  unitName: Target Practice
  unitSpec: 
  icon: {fileID: 2800000, guid: 1820afab5df9a4549a9f9f97d0b4f28c, type: 3}
  backgroundColor: {r: 0.8588235, g: 0.8588235, b: 0.854902, a: 1}
  textColor: {r: 0.4, g: 0.4, b: 0.4, a: 1}
  typeIcon: {fileID: 21300000, guid: 423717ccb76a74e489e5d288c5af5780, type: 3}
  type: HEALER
  description: 
  hitboxScale: {x: 1, y: 1, z: 1}
  selectionCircleScale: {x: 2, y: 2, z: 2}
  mouseHitboxScale: {x: 3, y: 1, z: 3}
  hitAnimationType: 13
  dieAnimationType: 1
  animationSpeedMultiplier: 1
  supportsStopWalkAnimation: 0
  isLeftHandClosed: 0
  isRightHandClosed: 0
  dualWields: 0
  runAnimation: {fileID: 7400000, guid: c9ed3c390c9e59a4fb671074d5a7b713, type: 3}
  sprintAnimation: {fileID: 7400000, guid: c9ed3c390c9e59a4fb671074d5a7b713, type: 3}
  idleAnimation: {fileID: 7400000, guid: 8ac07673d14b4cf48997a4d9e236c55a, type: 3}
  stopWalkAnimation: {fileID: 0}
  footstepSounds: []
  passiveIcon: {fileID: 21300000, guid: d3857588363cc674ea1157723c39247f, type: 3}
  passiveName: 
  passiveDescription: 
